import React from 'react';
import { FormControl, Input } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import InputLabel from './InputLabel';

type TextInputProps = {
  icon?: IconType;
  label: string;
  required?: boolean;
  placeholder?: string;
  fieldKey: string;
  register: UseFormRegister<FieldValues>;
};

const TextInput = ({
  icon,
  label,
  placeholder,
  required = false,
  register,
  fieldKey,
}: TextInputProps) => {
  return (
    <FormControl>
      <InputLabel icon={icon} required={required} label={label} />
      <Input
        {...register(fieldKey, { required })}
        focusBorderColor="#515151"
        p="1rem"
        placeholder={placeholder}
      />
    </FormControl>
  );
};

export default TextInput;
